import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

class Auth {
  constructor() {
    makeAutoObservable(this);

    makePersistable(this, {
      name: 'auth',
      properties: [
        'user',
        'token',
        'color',
        'workflowId',
        'workflowName',
        'permission',
        'features'
      ],
      storage: window.localStorage
    });

    this.authorize = this.authorize.bind(this);
    this.logout = this.logout.bind(this);
    this.setPermission = this.setPermission.bind(this);
    this.setFeatures = this.setFeatures.bind(this);
    this.setRole = this.setRole.bind(this);
    this.setWorkflow = this.setWorkflow.bind(this);
  }

  user = null;
  token = null;
  color = '#6A69C6';
  workflowId = null;
  workflowName = '';
  permission = {};
  features = {};
  // In-memory USER_ROLES value from the current-user endpoint. Read by
  // plain-JS modules (audit queue) that can't call React hooks. Reviewer
  // accounts must skip several endpoints (statistics-jobs,
  // audit-logs/events) that return 403 for that role.
  // NOT persisted on purpose — a stale 'Approver' value from a previous
  // session on the same browser must never block a fresh regular user's
  // requests before their own current-user query resolves. Every fresh
  // page load starts at null (gates open) and hydrates from the query.
  role = null;

  authorize(user, token) {
    this.user = user;
    this.token = token;
  }

  setPermission(data) {
    this.permission = data;
  }

  setFeatures(data) {
    this.features = data || {};
  }

  setRole(role) {
    this.role = role ?? null;
  }

  logout() {
    this.user = null;
    this.token = null;
    this.workflowId = null;
    this.role = null;
  }

  setWorkflow(id, name) {
    this.workflowId = id;
    this.workflowName = name;
  }
}

const authStore = new Auth();

export default authStore;
